'use client';

import { createContext, useContext } from 'react';
import { IJWTPayload } from '../../api/auth';

interface SessionContextType {
  userData: IJWTPayload | null;
  loading: boolean;
  refreshSession: () => void;
  setSessionData: (data: IJWTPayload | null) => void;
}

export const SessionContext = createContext<SessionContextType | undefined>(undefined);

export const useSession = (): SessionContextType => {
  const context = useContext(SessionContext);
  if (context === undefined) {
    throw new Error('useSession must be used within a SessionProvider');
  }
  return context;
};
